import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/sender',
      name: 'sender',
      component: () => import('./views/trackingLabels/SenderInfo.vue'),
    },
    {
      path: '/receiver',
      name: 'receiver',
      component: () => import('./views/trackingLabels/ReceiverInfo.vue'),
    },
    {
      path: '/view-contact/:id',
      name: 'viewContact',
      component: () => import('./views/trackingLabels/ContactView.vue'),
    },
    {
      path: '/add-contact/',
      name: 'addContact',
      component: () => import('./views/trackingLabels/ContactView.vue'),
    },
    {
      path: '/delivery-request/:refCode',
      name: 'deliveryRequest',
      component: () => import('./views/delivery/Delivery.vue'),
    },
    {
      path: '/view-delivery/:id',
      name: 'viewDelivery',
      component: () => import('./views/delivery/Delivery.vue'),
    },
    {
      path: '/delivery-contact',
      name: 'deliveryContact',
      component: () => import('./views/delivery/DeliveryContact.vue'),
    },
    {
      path: '/label-history',
      name: 'labelHistory',
      component: () => import('./views/trackingLabels/LabelHistory.vue'),
    },
    {
      path: '/send-request',
      name: 'sendRequest',
      component: () => import('./views/trackingLabels/SendRequest.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/trackingLabels/ContactList.vue'),
    },
    {
      path: '/request-contact/:refCode',
      name: 'requestContact',
      component: () => import('./views/trackingLabels/ContactList.vue'),
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/service/Detail.vue'),
    },
    {
      path: '/promptpost',
      name: 'promptpost',
      component: () => import('./views/service/PromptPost.vue'),
    },
    {
      path: '/ems',
      name: 'ems',
      component: () => import('./views/service/EMS.vue'),
    },
    {
      path: '/eCo-Post',
      name: 'eCo-Post',
      component: () => import('./views/service/eCo-Post.vue'),
    },
    {
      path: '/ePacket',
      name: 'ePacket',
      component: () => import('./views/service/ePacket.vue'),
    },
    {
      path: '/lineman',
      name: 'lineman',
      component: () => import('./views/service/Lineman.vue'),
    },
    {
      path: '/logispost',
      name: 'logispost',
      component: () => import('./views/service/Logispost.vue'),
    },
    {
      path: '/ems-world',
      name: 'emsWorld',
      component: () => import('./views/service/EMSWorld.vue'),
    },
    {
      path: '/ems-one-price',
      name: 'emsOnePrice',
      component: () => import('./views/service/EMSOnePrice.vue'),
    },
    {
      path: '/location',
      name: 'location',
      component: () => import('./views/location&support/Location.vue'),
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: () => import('./views/location&support/FAQ.vue'),
    },
    {
      path: '/termsAndConditions',
      name: 'termsAndConditions',
      component: () => import('./views/terms&conditions/TermsAndConditions.vue'),
    },
    {
      path: '/tracking-receipt',
      name: 'trackingReceipt',
      component: () => import('./views/trackingReceipt/TrackingReceiptView.vue'),
    },
    {
      path: '/tracking-register',
      name: 'trackingRegister',
      component: () => import('./views/trackingRegister/TrackingRegisterView.vue'),
    },
    { path: '/', redirect: { name: 'receiver' }},
  ],
});
